<template>
  <div class="icon-item" :class="{'is-selected' : isSelected}" @click="handleClick">
    <template v-if="iconType !== 'image'">
      <div class="icon-con">
        <i :class="icon" aria-hidden="true" />
      </div>

      <div class="icon-text">
        <span>{{ text }}</span>
      </div>
    </template>

    <img v-if="iconType === 'image'" class="icon-img" :src="imgRender(icon)" alt="图片" aria-hidden="true" />
  </div>
</template>

<script>
export default {
  name: 'IconItem',
  props: {
    iconType: {
      type: String,
      default: 'icon'
    },
    icon: {
      type: String,
      required: true
    },
    text: {
      type: String,
      default: ''
    },
    imgRender: {
      type: Function,
      default: (icon) => {
        return icon;
      }
    },
    isSelected: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClick() {
      this.$emit('click', !this.isSelected);
    }
  }
};
</script>

<style lang="scss" scoped>

.icon-item {
  width: 110px;
  height: 100px;
  border: 1px solid #ebeef5;
  padding: 15px 5px 10px 5px;
  text-align: center;
  overflow: hidden;

  &:hover, &.is-selected {
    background-color: #e1edfb;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    cursor: pointer;

    .icon-img {
      opacity: 0.6;
    }
  }

  .icon-con {
    margin-bottom: 10px;
    line-height: 1;

    > i {
      min-width: 32px;
      min-height: 32px;
      font-size: 32px;
      color: #666;
      speak: none;
      font-style: normal;
      font-weight: 400;
      font-variant: normal;
      text-transform: none;
      line-height: 1;
      vertical-align: baseline;
      display: inline-block;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }

    [class*=" le-icon-"], [class^=le-icon-] {
      font-family: "LeFont", serif;
    }

    i[class*=" tp-"], i[class^=tp-], [class*=" le-tp-icon-"], [class^=le-tp-icon-] {
      font-family: "LeTpFont", serif;
    }
  }


  .icon-text {
    height: 30px;
    line-height: 1;
    margin: 0;
    padding: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;

    > span {
      font-size: 14px;
      color: #666;
    }
  }

  .icon-img {
    width: 110px;
    height: 100px;
    margin: -20px;
    border: 1px solid #ebeef5;
  }
}
</style>
